// extracted by mini-css-extract-plugin
export var layoutContainer = "_a8-0";
export var layoutContainerNoRounding = "_a8-6";
export var layoutContainerOpen = "_a8-5";
export var layoutContainerResizing = "_a8-1";
export var mainContent = "_a8-2";
export var resizeDivider = "_a8-3";
export var slidePanel = "_a8-4";